import { useEffect, useRef, useState } from "react";
import { LazyMountOnVisibleProps } from "../Utils/Types";
import { LazyMountConfig } from "../Utils/Constants";

export default function LazyMountOnVisible(props: LazyMountOnVisibleProps) {
  const {
    children,
    minHeight = LazyMountConfig.defaultMinHeight,
    rootMargin = LazyMountConfig.defaultRootMargin,
  } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) return;
    const containerNode = containerRef.current;
    if (!containerNode) return;

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setIsVisible(true);
          intersectionObserver.disconnect();
        }
      },
      { rootMargin }
    );

    intersectionObserver.observe(containerNode);
    return () => intersectionObserver.disconnect();
  }, [isVisible, rootMargin]);

  return (
    <div ref={containerRef} style={isVisible ? undefined : { minHeight }}>
      {isVisible ? children : null}
    </div>
  );
}
